import {LadingErrorParams} from "@/modules/ladingerror/params";
import http from "@/shared/services/http";

export const listLadingError = (params?: LadingErrorParams) => http.get(`v1/lading-errors`, {params});
export const allLadingError = (params?: LadingErrorParams) => http.get(`v1/lading-errors/all`, {params});
export const singleLadingError = (id: number) => http.get(`v1/lading-errors/${id}`);
export const updateLadingError = (id: number, data: any) => http.put(`v1/lading-errors/${id}`, data);
export const createLadingError = (data: any) => http.post(`v1/lading-errors`, data)
